/**
 * Pub/sub contract for the PDF download-options flow.
 *
 * Two producers dispatch {@link DOWNLOAD_REQUESTED_EVENT}:
 *  - DocumentShow's header Download icon (React)
 *  - The PSPDFKit toolbar's custom Download button (non-React — lives inside
 *    the PSPDFKit DOM and can't read React props)
 *
 * One consumer (DocumentPDFViewer) subscribes, inspects the live annotation
 * count, and either opens the dialog or streams the original immediately.
 *
 * The event fires on `window` today, which assumes a single active PSPDFKit
 * viewer per page (enforced elsewhere by the window.PSPDFKIT_INSTANCE global).
 * If we ever mount two viewers side-by-side, this contract needs to scope
 * dispatches to a shared element ref instead.
 */

export const DOWNLOAD_REQUESTED_EVENT = 'liscio:pdf-download-requested';

/** Payload sent with the {@link DOWNLOAD_REQUESTED_EVENT} CustomEvent. */
export type DownloadRequestedDetail = {
  /** Pre-signed attachment URL for the uploaded PDF. Used when the user
   * chooses "download original" or when the document has no annotations. */
  originalUrl: string;
};
